module.exports = __webpack_public_path__ + "static/media/ellipse1.e90fb34e.svg";